export default __webpack_public_path__ + "static/media/login_bg_desktop.6b30d142.jpg";